import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteDockCarrierActions } from 'store/ducks/settings/dock-carrier';

export function* deleteDockCarrierRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/dock-carriers/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteDockCarrierActions.success(data));
    notify('success', 'Transportadora removida com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteDockCarrierActions.failure(errorMessage));
  }
}
